import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { PiPaperPlaneRightFill } from "react-icons/pi";

const EmailTemplate = () => {
  return (
    <section className="email-section">
      <Container>
        <Row className="justify-content-center text-center">
          <Col lg={12}>
            <h4 className="email-title">Stay Informed, Stay Ahead</h4>
            <p className="email-subtitle">
              Get the latest AI-powered research summaries delivered straight to
              your inbox
            </p>

            <Form className="email-form">
              <Form.Control
                type="email"
                placeholder="Enter your email address"
                className="email-input"
              />
              <Button type="submit" className="email-btn">
                <PiPaperPlaneRightFill />
              </Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default EmailTemplate;
